module.exports = __webpack_public_path__ + "static/dps-593e5745b2903333ff9abfbb1dd1bcd7.png";